import nookies, { setCookie, destroyCookie } from 'nookies';

export class Cookie {
  static get(ctx = null, key) {
    const cookies = nookies.get(ctx);

    return cookies[key];
  }

  static getJSON(ctx = null, key) {
    const cookies = nookies.get(ctx);

    try {
      return JSON.parse(cookies[key]);
    } catch (error) {
      return null;
    }
  }

  static set(ctx = null, key, value, params) {
    setCookie(ctx, key, value, params);
  }

  static remove(ctx = null, key) {
    destroyCookie(ctx, key, { path: '/' });
  }

  static has(ctx = null, key) {
    const cookies = nookies.get(ctx);

    return !!cookies[key];
  }
}
